module.exports = __webpack_public_path__ + "img/wheel.5ce2b7f2.png";